module.exports = __webpack_public_path__ + "static/media/play_bg.58ff3af3.svg";